import { Outlet, Link, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { auth } from '../lib/supabase'

export default function AdminLayout() {
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(true) // Changed to true by default for desktop

  const handleLogout = async () => {
    await auth.signOut()
    navigate('/login')
  }

  const menuItems = [
    { path: '/admin', label: 'Dashboard', icon: '📊' },
    { path: '/admin/usuario', label: 'Mi Perfil', icon: '👤' },
    { path: '/admin/marcas', label: 'Tiendas', icon: '🏪' },
    { path: '/admin/eventos', label: 'Eventos', icon: '🎉' },
    { path: '/admin/descuentos', label: 'Descuentos', icon: '🏷️' },
    { path: '/admin/comentarios', label: 'Comentarios', icon: '💬' },
    { path: '/admin/faqs', label: 'FAQs', icon: '❓' },
    { path: '/admin/legal', label: 'Legal', icon: '📄' },
    { path: '/admin/crm', label: 'CRM', icon: '📈' },
    { path: '/admin/website', label: 'Website', icon: '🌐' },
    { path: '/admin/site-config', label: 'Config. Sitio', icon: '🏢' },
    { path: '/admin/contactos', label: 'Contactos', icon: '✉️' },
    { path: '/admin/reclamos', label: 'Reclamos', icon: '📋' },
  ]

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <div style={{
        display: 'flex',
        minHeight: '100vh',
        background: 'var(--background)'
      }}>
      {/* Sidebar */}
      <aside 
        style={{
          background: 'var(--ctaBg)',
          color: 'var(--ctaText)',
          width: '280px',
          flexShrink: 0,
          position: 'fixed',
          height: '100vh',
          overflowY: 'auto',
          zIndex: 1000,
          boxShadow: '4px 0 12px rgba(0, 0, 0, 0.1)',
          left: menuOpen ? 0 : '-280px',
          top: 0,
          transition: 'left 0.3s ease'
        }}
      >
        <div style={{
          padding: '1.5rem',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <img
            src="https://ffbzkwlpbswgbngwvyvp.supabase.co/storage/v1/object/public/assets/logo/PlazaAurora_logo_blanco.png"
            alt="Plaza Aurora"
            style={{ height: '28px', width: 'auto', display: 'block' }}
/>
          <p style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 'var(--small)',
            color: 'rgba(255, 255, 255, 0.7)',
            margin: '0.8rem 0 0 0'
          }}>
            Panel de Administración
          </p>
        </div>
        
        <nav style={{ marginTop: '1rem' }}>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.875rem 1.5rem',
                color: 'var(--ctaText)',
                textDecoration: 'none',
                fontFamily: "'Inter', sans-serif",
                fontSize: 'var(--body)',
                fontWeight: 'var(--medium)',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
            >
              <span style={{ fontSize: '1.25rem' }}>{item.icon}</span>
              <span>{item.label}</span>
            </Link>
          ))}
          
          <button
            onClick={handleLogout}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.875rem 1.5rem',
              color: 'var(--ctaText)',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontFamily: "'Inter', sans-serif",
              fontSize: 'var(--body)',
              fontWeight: 'var(--medium)',
              width: '100%',
              textAlign: 'left',
              marginTop: '1rem',
              borderTop: '1px solid rgba(255, 255, 255, 0.1)',
              paddingTop: '1.5rem',
              transition: 'background-color 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
          >
            <span style={{ fontSize: '1.25rem' }}>🚪</span>
            <span>Cerrar Sesión</span>
          </button>
        </nav>
      </aside>

      {/* Main Content */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        marginLeft: menuOpen ? '280px' : '0',
        transition: 'margin-left 0.3s ease'
      }}
      >
        {/* Top Bar */}
        <header style={{
          background: 'var(--surface)',
          boxShadow: 'var(--shadow-soft)',
          padding: '1rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid var(--mutedStroke)'
        }}>
          {/* Toggle Sidebar Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              fontSize: '1.5rem',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: 'var(--textPrimary)',
              padding: '0.5rem',
              transition: 'transform 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
          <h1 style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: 'var(--h3)',
            fontWeight: 'var(--bold)',
            color: 'var(--textPrimary)',
            margin: 0
          }}>
            Panel de Administración
          </h1>
          <Link 
            to="/" 
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 'var(--small)',
              color: 'var(--accentPurpleDark)',
              textDecoration: 'none',
              fontWeight: 'var(--medium)',
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
            onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
          >
            Ver Sitio Web →
          </Link>
        </header>

        {/* Content */}
        <main style={{
          flex: 1,
          overflowY: 'auto',
          padding: '1.5rem'
        }}>
          <Outlet />
        </main>
      </div>
      </div>
    </>
  )
}
